import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative bg-hero-gradient text-bakery-cream pt-24 pb-32 px-6 overflow-hidden" data-id="element-68">
      {/* Subtle background texture/pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#D4A853 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-69"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-70">
        <div className="text-center mb-12" data-id="element-71">
          <FadeIn data-id="element-72">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-bakery-cream mb-6 leading-tight" data-id="element-73">
              Manual del Pan:{' '}
              <span className="text-bakery-amber italic" data-id="element-74">Cero Errores</span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-75">
            <h2 className="text-xl md:text-2xl text-bakery-tan/90 font-light max-w-3xl mx-auto leading-relaxed mb-10" data-id="element-76">
              La guía definitiva de 20 panes legendarios pesados al gramo para
              resultados de panadería profesional en menos de 2 horas{' '}
              <span className="font-medium text-bakery-amber" data-id="element-77">
                (Sin Tazas y Sin Frustraciones)
              </span>
              .
            </h2>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-78">
            <CTAButton data-id="element-79">👉 ¡QUIERO MI MANUAL Y EMPEZAR A HORNEAR YA!</CTAButton>
          </FadeIn>
        </div>

        <FadeIn delay={0.6} direction="up" className="mt-16" data-id="element-80">
          <div className="relative max-w-4xl mx-auto" data-id="element-81">
            <div className="absolute -inset-4 bg-bakery-amber/20 blur-2xl rounded-full opacity-50" data-id="element-82"></div>
            <img src="https://cdn.magicpatterns.com/uploads/2x1WuxZYBuwzpHcEc3vCUy/Manual_del_pan_cero_errores.png" alt="Mockup del Manual del Pan Cero Errores en múltiples dispositivos" className="relative w-full h-auto object-contain drop-shadow-2xl" data-id="element-83" />
          </div>
        </FadeIn>
      </div>

      {/* Decorative bottom wave */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-bakery-cream" style={{
      clipPath: 'polygon(0 100%, 100% 100%, 100% 0, 0 100%)'
    }} data-id="element-84"></div>
    </section>;
}